import { ConditionalWrapper } from './ConditionalWrapper';

export type { TypeConditionalWrapperProps } from './types';
export default ConditionalWrapper;
